import './polyfills';
import './integrations';
import './globalStyleImports';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {enableBatching} from 'redux-batched-actions';

import {AppEntryProviders} from './AppEntryProviders';
import {initializeAppStartup} from './appStartup';
import {urlPrefixed} from './config';
import {AppWithRoutes} from './routes/AppWithRoutes';
import {store} from './setup';
import uninstallServiceWorker from './uninstallServiceWorker';

uninstallServiceWorker();
initializeAppStartup();

const root = createRoot(document.getElementById('root')!);

root.render(
  <AppEntryProviders>
    <BrowserRouter basename={urlPrefixed(undefined, false)}>
      <AppWithRoutes />
    </BrowserRouter>
  </AppEntryProviders>
);

const hot = import.meta.hot;
if (hot) {
  hot.accept('./reducers', updatedCreateRootReducer => {
    store.replaceReducer(enableBatching(updatedCreateRootReducer()));
  });
  hot.accept('./routes', async ({default: NextApp}) => {
    root.render(<NextApp />);
  });
}
